import { render, staticRenderFns } from "./generate-statement.vue?vue&type=template&id=0b6f2b4c&scoped=true&"
import script from "./generate-statement.vue?vue&type=script&lang=js&"
export * from "./generate-statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f2b4c",
  null
  
)

export default component.exports